import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TEvent } from "protico-sdk";
// TODO: move this to event context
type TEventState = {
  events: Array<TEvent>;
};
const initialState: TEventState = {
  events: [],
};

export const eventStateSlice = createSlice({
  name: "eventState",
  initialState,
  reducers: {
    addEvent: (state, action: PayloadAction<TEvent>) => {
      state.events.push(action.payload);
    },
  },
});
// Action creators are generated for each case reducer function
export const { addEvent } = eventStateSlice.actions;
export default eventStateSlice.reducer;
